export default __webpack_public_path__ + "static/media/pin-monitor-online.cb51d92d.png";